(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/components/message-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/components/message-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const MESSAGE = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants.names.MESSAGE;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants.TEXTS.MESSAGE,
  LABEL = _svs$ticket_partner$d.LABEL,
  MAX = _svs$ticket_partner$d.MAX,
  MAX_ERROR = _svs$ticket_partner$d.MAX_ERROR,
  ROWS = _svs$ticket_partner$d.ROWS;
const MessageInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state;
  return React.createElement(TextInput, {
    errorMessageMax: MAX_ERROR,
    id: MESSAGE,
    isMultiline: true,
    isRequired: false,
    label: LABEL,
    max: MAX,
    name: MESSAGE,
    onChange: handleChange,
    rows: ROWS,
    value: state.message
  });
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.components.MessageInput = MessageInput;

 })(window);